import DimensionIcon from "@/components/dimension-icon";
import { PreviousEditionsResponseContent } from "@/requests/questionnaries/previous-editions.request";
import { DimensionId } from "@/types/questionnaries";
import { Row } from "@tanstack/react-table";
import { FC } from "react";

type DimensionCellProps = {
  row: Row<PreviousEditionsResponseContent>;
  dimensionId: DimensionId;
};

const DimensionCell: FC<DimensionCellProps> = ({ row, dimensionId }) => {
  const score = row.original.dimensionsScores.find(
    (dimension) => dimension.dimension === dimensionId,
  )?.score;

  return (
    <div className="flex items-center gap-2">
      <DimensionIcon dimensionId={dimensionId} />
      {score ? <strong className="font-bold">{score}</strong> : "No aplica"}
    </div>
  );
};

export default DimensionCell;
